<template>
  <section class="news-recents" :class="{ 'news-recents--home': buttonMobile }">
    <div :class="getPage()">
      <div class="block-header block-header--small d-flex align-items-center" v-if="titleVisible">
        <h2 v-text="translate.titleColumns" />
        <p class="d-none d-xl-block subtitle">
          {{ translate.subtitleColumns }}
        </p>
        <NuxtLink :to="{ name: 'language-colunas' }" class="button d-none d-md-inline-flex">
          {{ translate.seeAllColumns }} <i class="icon-arrow-right"></i></NuxtLink>
      </div>
      <client-only>
        <div class="tab-scroll">
          <tabs v-model="selectedTab">
            <tab v-for="(tab, i) in tabsList" :key="`t${i}`" :val="tab.id" :label="tab.category" :indicator="true"
              @click="route.name != 'language' ? changeCategory(tab) : ''" :id="`tab${tab.id}`" />
          </tabs>
        </div>
        <tab-panels v-model="selectedTab" :animate="route.name != 'language' ? false : true" :swipeable="true"
          @update:modelValue="changeSwipe">
          <tab-panel v-for="(tab, i) in tabsList" :key="`tp${i}`" :val="tab.id">
            <list-itens-column v-if="!isMobile() || !buttonMobile" :cards="tab.cards.slice(0, 4)" />
            <list-itens-column-mobile v-else :cards="tab.cards.slice(0, 3)" />
          </tab-panel>
        </tab-panels>
      </client-only>
      <!-- Grid do desktop: no HTML também no mobile, escondido por CSS (< 770);
           com v-if no isMobile(), false no servidor, a hidratação divergia -->
      <div class="cards-home-mobile">
        <CardsHomepage :posts="tabsHomepage" />
      </div>

      <div class="row d-flex align-items-center justify-content-center"
        v-if="buttonMore && !isMobile() && tabsHomepage.length >= limit">
        <button type="button" class="more-blog mb-1 p-3 col-lg-3 col-8" @click="readMore">
          {{ translate.readMore }}
          <font-awesome :icon="['fas', 'arrow-down']" size="md" />
        </button>
      </div>

      <div class="d-flex justify-content-center button--mobile pb-4" v-if="buttonMobile">
        <NuxtLink :to="{ name: 'language-colunas' }" class="button button--outline-white d-md-none">
          {{ translate.seeAllColumns }} <i class="icon-arrow-right"></i>
        </NuxtLink>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import CardsHomepage from "@/components/ColumnsCards/CardsHomepage.vue";
import { isMobile } from "@/shared/utils/mobile";
import translateMain from "@/tradutors/menu";
import { Tabs, Tab, TabPanels, TabPanel } from "vue3-tabs";
import ListItensColumn from "./ListItensColumn.vue";
import ListItensColumnMobile from "./ListItensColumnMobile.vue";
import api from "@/api";

const router = useRouter();
const emits = defineEmits(["getArticleTagId"]);
const route = useRoute();
const translate = computed(() =>
  route.params.language == "pt-br" ? translateMain.portugues : translateMain.ingles
);

const props = defineProps(["titleVisible", "buttonMobile", "buttonMore"]);

const tabsList = ref<any>([]);
const tabsHomepage = ref([]);
const selectedTab = ref(9999);
const limit = ref(3);

watch(tabsList, (val: any) => {
  if (route.name == "language-colunas-catergoriaId-categoriaName") {
    selectedTab.value = Number(route.params.catergoriaId);
  } else {
    selectedTab.value = val[0].id;
  }
});
watch(selectedTab, (val: number) => {
  emits("getArticleTagId", { articleTagId: val });
  limit.value = 3;
  getColumnsMobile();
  if (route.name == "language-colunas-catergoriaId-categoriaName") {
    setTimeout(() => {
      document.getElementById('tab' + val)?.scrollIntoView({ behavior: "instant", block: "center", inline: 'center' });
    }, 500)
  }
});

onMounted(() => {
  getColumns();
});

function getPage() {
  return props.titleVisible ? "container " : "row bg-light";
}
function getColumns() {
  api
    .get(
    `v1/home/getColumns?language=${route.params.language
      }&limit=10&mobile=${isMobile()}${props.buttonMobile ? "&home=true" : ""}`
    )
    .then(({ data }) => {
      tabsList.value = data.columns;
    });
}
function getColumnsMobile() {
  if (props.buttonMobile && !isMobile()) {
    api
      .get(
        `v1/colunas/getColumns?articletag=${selectedTab.value}&language=${route.params.language ?? ""
        }&limit=${limit.value}&mobile=${isMobile()}&home=true`
      )
      .then(({ data }) => {
        tabsHomepage.value = data.postsColumns
          .slice(0, 2)
          .concat(data.postsColumns.slice(3, 6))
          .concat(data.postsColumns.slice(7));
      });
  }
}
async function readMore() {
  limit.value += 3;
  await getColumnsMobile();
}
function changeCategory(data: any) {
  let routeRedirect = data.id == 9999 ? "language-colunas" : "language-colunas-catergoriaId-categoriaName";
  router.push({
    name: routeRedirect,
    params: {
      language: route.name.language,
      catergoriaId: data.id,
      categoriaName: data.slugCategory,
    },
  });
}

function changeSwipe(val: number) {
  if (route.name != "language") {
    tabsList.value.forEach((item) => {
      if (item.id == val) {
        changeCategory(item)
      }
    });    
  }
}

</script>

<style scoped lang="css">
.tab-panels :deep(.tab-panel) {
  width: 98%;
}

.news-recents {
  padding-bottom: 0px;
}

.news-recents .block-header {
  margin-top: -16px;
  margin-bottom: -7px;
}

/* iPad Mini (768px): o botão -Acesse todas as colunas- aparece a partir de 768px
   (Bootstrap d-md-inline-flex, md=768), mas o justify-content:space-between do
   .block-header (global _block-header.scss) só entra em >=769px (mixin md=769).
   Nesse 1px de diferença o botão fica colado ao título em 768px. Alinhar à direita
   já em 768px, como nos demais iPads. Abaixo de 768px o botão fica oculto (só o
   título no header), então space-between é inócuo. */
@media screen and (min-width: 768px) {
  .news-recents .block-header {
    justify-content: space-between;
  }
}

h2 {
  font-family: "Bebas-Neue-Light";
  color: #000000;
  font-size: 64px;
  font-weight: 300;
  letter-spacing: 0;
}

.block-header :deep(h2) {
  margin-right: 34px;
}

.subtitle {
  height: 42px;
  color: #5b5858;
  font-family: "Roboto-Medium";
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 21px;
}

.column-pagination {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.column-pagination .bullet-class {
  background: #ccc;
  width: 8px;
  height: 8px;
  margin: 0 10px;
  border-radius: 10px;
}

.column-pagination .bullet-active {
  background: #000;
  width: 12px;
  height: 12px;
}

.tabs {
  cursor: pointer;
  margin-left: unset;
}

.tabs :deep(.active) {
  border: 0px;
}

.tabs :deep(.active::after) {
  content: "";
  background: #b20000;
  position: absolute;
  left: 20%;
  width: 50%;
  height: 3px;
}

.tabs :deep(.tab) {
  padding: 6px 12px 0px 0px;
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 14px;
  letter-spacing: 0;
}

.tabs :deep(.active .tab) {
  color: #b20000;
  border-color: #b20000;
  font-weight: bold;
}

.button {
  color: #ffffff;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  text-align: right;
  padding-left: 47px;
  padding-right: 49px;
}

.button--outline-white {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: #000000;
  border: none;
  color: #ffffff;
  border-radius: 30px;
  padding: 12px 28px;
  text-align: center;
  text-decoration: none;
}

.button--outline-white i {
  color: #b20000;
}

.more-blog {
  font-size: 1rem !important;
  font-weight: 500;
  background-color: black !important;
  border: 1px solid black !important;
  border-radius: 30px !important;
  color: white;
}

.more-blog svg {
  color: #b20;
  margin-left: 8px;
}

/* regras mobile 1400vp */
@media screen and (max-width: 1400px) {
  .tab-scroll {
    position: relative;
    overflow: auto;
    min-height: 33px;
  }

  .tabs {
    width: 1400px;
  }

}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .cards-home-mobile {
    display: none;
  }
  h2 {
    font-family: "Bebas-Neue-Light";
    color: #000000;
    font-size: 48px;
    font-weight: 300;
    letter-spacing: 0;
  }

  .news-recents .block-header {
    margin-top: 10px;
  }

  .tabs[data-v-77a7dba6] .active {
    border-bottom: 3px solid #ffffff;
  }

  /* Fundo claro aplicado apenas na homepage (buttonMobile=true) */
  .news-recents--home {
    background-color: #F0F0F0;
  }

  .news-recents--home :deep(.container) {
    background-color: #F0F0F0;
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .news-recents--home h2 {
    color: #1D1D1D;
  }

  .news-recents--home .tabs :deep(.tab) {
    color: #1D1D1D;
  }

  .news-recents--home .tabs :deep(.active .tab) {
    color: #b20000;
  }

  .news-recents--home .tabs :deep(.active) {
    border-bottom-color: transparent;
  }

  .news-recents--home :deep(.mobile-columns) {
    background: transparent;
  }

  .news-recents--home :deep(.mobile-column-item__title) {
    color: #1D1D1D;
  }

  .news-recents--home .button--mobile {
    padding-top: 18px;
  }
}
</style>
